const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-product-frac-ui/shared/registries/metrics-registry");